import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDependentToLinked(): UseMutationResult<
  AxiosResponse,
  AxiosError<ErrorMessage>,
  {
    athleteId: string;
    email: string;
  }
> {
  const queryClient = useQueryClient();

  const dependentToLinked = ({
    athleteId,
    email,
  }: {
    athleteId: string;
    email: string;
  }): Promise<AxiosResponse<{}>> => {
    return client.put(`athletes/${athleteId}/dependent-to-linked/`, { email });
  };

  return useMutation(dependentToLinked, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['athletes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['connectedAthletes'],
      });
    },
  });
}
